/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス月別使用量情報
 */
export interface Szma301aResGasMnEmpamtDto {
    /**
     * 検針年月
     */
    inspectionyearmonthday?: string;
    /**
     * 使用量種別コード
     */
    empamtClscode?: string;
    /**
     * 使用量種別コード名称
     */
    empamtClsfyCodeaname?: string;
    /**
     * 使用量
     */
    elecCsp?: string;
}

